module.exports = __webpack_public_path__ + "img/2.82465e1e.jpg";